import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React__default from 'react';
import { useResizeDetector } from 'react-resize-detector';

var handleTabKeyDown = function handleTabKeyDown(e, clickedItem, items, onTabChange, refMap) {
  if (e.key === 'ArrowRight') {
    e.preventDefault();
    var clickedIdx = items.findIndex(function (item) {
      return clickedItem.id === item.id;
    });
    var next = items[clickedIdx + 1];
    if (next) {
      onTabChange(next.id);
      var nextRef = refMap.get(next);
      // istanbul ignore else - sanity
      if (nextRef && nextRef.current) nextRef.current.focus();
    }
  }
  if (e.key === 'ArrowLeft') {
    e.preventDefault();
    var _clickedIdx = items.findIndex(function (item) {
      return clickedItem.id === item.id;
    });
    var previous = items[_clickedIdx - 1];
    if (previous) {
      onTabChange(previous.id);
      var previousRef = refMap.get(previous);
      // istanbul ignore else - sanity
      if (previousRef && previousRef.current) previousRef.current.focus();
    }
  }
};
var useHorizontalScroll = function useHorizontalScroll(targetRef) {
  var _React$useState = React__default.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    scrolling = _React$useState2[0],
    setScrolling = _React$useState2[1];
  var _React$useState3 = React__default.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    scrollEndLeft = _React$useState4[0],
    setScrollEndLeft = _React$useState4[1];
  var _React$useState5 = React__default.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    scrollEndRight = _React$useState6[0],
    setScrollEndRight = _React$useState6[1];
  var onResize = React__default.useCallback(/* istanbul ignore next - react-resize-detector does not have API to trigger these in tests, also this has only visual effects that should be tested manually */
  function () {
    var _targetRef$current, _targetRef$current2;
    if (!targetRef.current) {
      return;
    }
    setScrolling(((_targetRef$current = targetRef.current) === null || _targetRef$current === undefined ? undefined : _targetRef$current.scrollWidth) > ((_targetRef$current2 = targetRef.current) === null || _targetRef$current2 === undefined ? undefined : _targetRef$current2.clientWidth));
  }, [targetRef, setScrolling]);
  useResizeDetector({
    onResize: onResize,
    targetRef: targetRef,
    refreshMode: 'debounce',
    refreshRate: 0
  });
  var handleScrolling = React__default.useCallback(/* istanbul ignore next - react-resize-detector does not have API to trigger these in tests, also this has only visual effects that should be tested manually */
  function (_e) {
    if (!targetRef.current) {
      return;
    }
    if (targetRef.current.scrollLeft === 0) {
      setScrollEndLeft(true);
    } else {
      setScrollEndLeft(false);
    }
    if (targetRef.current.clientWidth + Math.ceil(targetRef.current.scrollLeft) >= targetRef.current.scrollWidth) {
      setScrollEndRight(true);
    } else {
      setScrollEndRight(false);
    }
  }, [setScrollEndLeft, setScrollEndRight, targetRef]);
  return {
    scrolling: scrolling,
    scrollEndLeft: scrollEndLeft,
    scrollEndRight: scrollEndRight,
    handleScrolling: handleScrolling
  };
};

export { handleTabKeyDown, useHorizontalScroll };
